
const MathIntroduction = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">

            <h1 className="tw-header font-bold text-gray-900 mb-4">Maths</h1>
            <p className="text-gray-600 tw-subtitle text-justify">
                Maths is the foundation for everything. Some may agree to this statement literally, while others only
                figuratively. The natural subjects, are subjects that branch off from Maths. For instance: Biology is
                dependant on chemistry, which is dependant on physics, which is dependant on maths. It can't be avoided,
                but it can be abstracted out.
            </p>
            <br/>
            <p className="text-gray-600 tw-subtitle text-justify">
              A question one could then have is: did we invent maths or did we find it. I'll dive more into that in the philosophy section.
            </p>
        </div>
    );
}

export default MathIntroduction;
